import { render, staticRenderFns } from "./ComparisonView.vue?vue&type=template&id=bf359936&scoped=true&"
import script from "./ComparisonView.vue?vue&type=script&lang=js&"
export * from "./ComparisonView.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonView.vue?vue&type=style&index=0&id=bf359936&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf359936",
  null
  
)

export default component.exports